export default __webpack_public_path__ + "static/media/ic-arrowRight.77d9ebf0.svg";